<template>
  <div class="setting-join-weibo">
    <div class="module-item-style">
      <div class="module-item-title">微博企业账号接入</div>
      <div class="join-tips">
        接入后你可以使用微聊统一接收与回复粉丝的私信消息。
      </div>
      <div class="wl-btn" @click="toBindWx">接入微博企业账号</div>
      <ul class="join-result">
        <li><span>*</span>由于微博开放平台API限制，只有企业微博「蓝V」才能正常接入微聊客服
        </li>
        <li><span>*</span>接入后，所有粉丝消息会被转发到微聊，但这并不影响在微博客户端中正常使用私信功能。</li>
      </ul>
      <ul class="join-content-container">
        <li class="bind-item" v-for="(item, i) in weiboList" :key="i">
          <div class="join-logo">
            <svg-icon icon-class="weibo"></svg-icon>
          </div>
          <div class="join-type-container">
            <div class="bind-name">{{item.weiboName}}</div>
          </div>
          <div class="join-operation-container">
            <span class="wl-btn unbind-wl" @click="unbindWL(item.id)">解除绑定 </span>
          </div>
        </li>
      </ul>
    </div>
    <!--    授权配置-->
    <el-dialog
        title="企业微博账号配置"
        width="680px"
        class="weiboConfig"
        :visible.sync="dialogFormVisible">
      <el-form ref="form" :model="configForm" label-width="120px">
        <el-form-item
            label="微博名称:"
            :rules="{
      required: true, message: '微博名称不能为空', trigger: 'blur'
    }">
          <el-input v-model="configForm.weiboName" placeholder="请填写微博名称"></el-input>
        </el-form-item>
        <el-form-item
            label="微博ID:"
            :rules="{
      required: true, message: '微博ID不能为空', trigger: 'blur'
    }">
          <el-input placeholder="请填写微博ID" v-model="configForm.weiboId"></el-input>
        </el-form-item>
        <el-form-item label="" class="configTips" v-if="dialogFormVisible && configInfo">
          <div>请用电脑登录微博账号，找到「粉丝服务」-->「开发者中心」设置以下参数：</div>
          <div>URL：{{configInfo.URL}}{{configForm.weiboId}}</div>
          <div>APPKEY：{{configInfo.APPKEY}}</div>
          <div>请将设置成功后取得的access_token填入下面输入框中</div>
        </el-form-item>
        <el-form-item
            label="access_token:"
            :rules="{
      required: true, message: 'access_token不能为空', trigger: 'blur'
    }">
          <el-input placeholder="请填access_token" v-model="configForm.accessToken"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="configConfirm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import appKeyImage from '@/assets/images/app_key.png'
  import appSecretImage from '@/assets/images/app_secret.png'

  export default {
    name: 'setting-join-weibo',
    data() {
      return {
        dialogFormVisible: false,
        weiboList: [],
        configForm: {
          weiboName: '',
          weiboId: '',
          accessToken: '',
        },
        configInfo: null
      }
    },
    created() {
      this.joinGetWEIBOList()
      this.joinGetWEIBOConfig()
    },
    mounted() {
    },
    methods: {
      configConfirm() {
        if (this.configForm.weiboName.trim().length === 0) {
          this.$message({
            message: '微博名称不能为空',
            type: 'error',
          })
          return false
        }
        if (this.configForm.weiboId.trim().length === 0) {
          this.$message({
            message: 'weiboId不能为空',
            type: 'error',
          })
          return false
        }
        if (this.configForm.accessToken.trim().length === 0) {
          this.$message({
            message: 'accessToken不能为空',
            type: 'error',
          })
          return false
        }
        this.$http.joinAddWEIBOAPI(this.configForm).then(res => {
          if (res.status == 1) {
            this.$message({
              message: res.msg,
              type: 'success',
            })
            this.dialogFormVisible = false
            this.joinGetWEIBOList()
          } else {
            this.$message({
              message: res.msg,
              type: 'error',
            })
          }
        })

      },
      toBindWx() {
        this.dialogFormVisible = true
      },
      joinGetWEIBOConfig(){
        this.$http.joinGetWEIBOConfigAPI().then(res => {
          if(res.status == 1){
            this.configInfo  = res.data
          }else {
            this.$message({
              message: '获取微博配置信息失败',
              type: 'error',
            })
          }
        })
      },
      joinGetWEIBOList() {
        this.$http.joinGetWEIBOListAPI().then(res => {
          if (res.status == 1) {
            console.log('list=', res)
            this.weiboList = res.data.weiboList
          }
        })
      },
      unbindWL(id) {
        this.$confirm('将要进行解绑操作, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http.joinDelWEIBOConfigAPI({
            id
          }).then(res => {
            if (res.status == 1) {
              this.joinGetWEIBOList()
              this.$message({
                message: res.msg,
                type: 'success',
              })
            } else {
              this.$message({
                message: res.msg,
                type: 'error',
              })
            }
          })
        }).catch(() => {
        })
      }
    }
  }
</script>

<style lang="scss">
  .setting-join-weibo {
    .join-tips {
      font-size: 12px;
      color: #999;
      line-height: 40px;
    }

    .join-result {
      padding: 15px;

      li {
        line-height: 22px;
        padding-bottom: 5px;

        span {
          color: #FF4E00;
          font-size: 16px;
          display: inline-block;
          padding-right: 8px;
        }
      }
    }

    .weiboConfig {
      .configTips {
        .el-form-item__content {
          background-color: #f4f4f4;
          font-size: 12px;
          padding: 10px;
          box-sizing: border-box;
          font-family: 'Microsoft YaHei';
        }
      }
    }

    .join-content-container {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      align-content: flex-start;
      padding-left: 0;

      .bind-item {
        width: 48%;
        min-width: 350px;
        font-size: 12px;
        display: flex;
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(228, 231, 237, 1);
        border-radius: 6px;
        padding: 15px 10px;
        align-items: center;
        margin-bottom: 10px;

        .join-logo {
          margin-right: 10px;

          .svg-icon {
            width: 40px;
            height: 40px;
            margin: 0;
          }
        }

        .join-type-container {
          width: 140px;

          .bind-name {
            padding: 0 5px 0 0;
            font-size: 14px;
            font-weight: bold;
            line-height: 18px;
          }

          .bind-type {
            font-size: 13px;

            span {
              color: $mainColor;
            }
          }
        }

        .join-operation-container {
          margin-left: auto;

          .wl-btn {
            padding: 0 10px;
          }

          .wl-btn + .wl-btn {
            margin-left: 15px;
          }

          .unbind-wl {
            border: 1px solid #F68541;
            color: #F68541;
            background-color: #fff;
          }

          .configShop {
            border: 1px solid $mainColor;
            color: $mainColor;
            background-color: #fff;
          }
        }
      }
    }

    .bind-way-radio-group {
      width: 100%;
      text-align: center;
    }

    .dialog-footer {
      text-align: center;
    }

    .appid-input {
      margin: 20px auto 0;
    }

    .el-form-item__label {
      color: #333;
      font-weight: bold;
    }

    .config-dialog {
      .help-icon {
        margin-top: 0;
        cursor: pointer;
      }
    }

  }
</style>
